import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from "moment-timezone";
import Datetime from "react-datetime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Form, Button, InputGroup, Alert, Spinner} from '@themesberg/react-bootstrap';
import { Toast, ToastContainer } from "react-bootstrap";
import { ChoosePhotoWidget } from "../components/Widgets";
import Profile3 from "../assets/img/team/avatar.png";
import { useAuth } from "../Context/AuthContext";
import { BASE_URL } from '../constants';

export const GeneralInfoForm = () => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [birthday, setBirthday] = useState("");
    const [gender, setGender] = useState("0"); 
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [defaultAvatar, setDefaultAvatar] = useState(Profile3);
    const [profilePhoto, setProfilePhoto] = useState(null);
    const [profilePhotoPreview, setProfilePhotoPreview] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { user, setUser } = useAuth();
  
    useEffect(() => {
        const fetchUserData = async () => {
          try {
            if (!user || !user.id) {
              throw new Error("User is not authenticated or ID is missing.");
            }
      
            const userId = user.id;
            const token = localStorage.getItem('token');
      
            if (!token) {
              throw new Error("Authorization token is missing.");
            }
      
            // Fetch user data using userId and token
            const response = await fetch(`${BASE_URL}/refugees/${userId}`, {
              method: "GET",
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });
      
            if (!response.ok) {
              throw new Error(`Failed to fetch user data: ${response.statusText}`);
            }
      
            const data = await response.json();
      
            // Destructure and validate the response data
            const { firstName, lastName, dateOfBirth, gender, email, phone, profilePhoto } = data;
            setFirstName(firstName || "");
            setLastName(lastName || "");
            setBirthday(moment(dateOfBirth).format("YYYY-MM-DD") || "");
            setGender(gender === "Female" ? "1" : "2");
            setEmail(email || "");
            setPhone(phone || "");
            setProfilePhoto(profilePhoto || "");

            
      
          } catch (error) {
            console.error("Error fetching user data:", error);
            setError(error.message || "An unexpected error occurred.");
          }
        };
      
        fetchUserData();
      }, [user]); 
      
  

      const handleProfilePhotoChange = (e) => {
        const file = e.target.files[0];
        setProfilePhoto(file); 
    
        if (file) {
            setProfilePhotoPreview(URL.createObjectURL(file));
        }
    };
    

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const formData = new FormData();
    
        // Append only updated fields
        if (firstName) formData.append("firstName", firstName);
        if (lastName) formData.append("lastName", lastName);
        if (birthday) formData.append("dateOfBirth", birthday);
        if (gender !== "0") formData.append("gender", gender === "1" ? "Female" : "Male");
        if (email) formData.append("email", email);
        if (phone) formData.append("phone", phone);
        if (password) formData.append("password", password);
        if (profilePhoto) formData.append("profilePhoto", profilePhoto);
    
        try {
            setIsLoading(true);
            const userId = user.id;
            const token = localStorage.getItem("token");
    
            if (userId && token) {
                const response = await axios.put(`${BASE_URL}/refugees/${userId}`, formData, {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                });
    
                if (response.status === 200) {
                    setIsLoading(false);
    
                    // Update localStorage for userData
                    const updatedUserData = { ...user, profilePhoto: response.data.profilePhoto };
                    localStorage.setItem("userData", JSON.stringify(updatedUserData));
                    setUser(updatedUserData); // Update auth context state
    
                    // Show success alert
                    setShowAlert(true);
                    setTimeout(() => {
                        setShowAlert(false);
                    }, 3000);
                } else {
                    throw new Error("Failed to save refugee information");
                }
            } else {
                throw new Error("User ID or token not available");
            }
        } catch (error) {
            console.error("Error saving refugee information:", error.message);
            setIsLoading(false);
            setError(error.message || "An unexpected error occurred.");
        }
    };
    

    return (
        <>
        <Card className="shadow-lg border-0 rounded">
          <Card.Body className="p-4 p-md-6">
            <h3 className="text-center mb-4 text-primary">Profile Informations</h3>
      
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col xs={12} md={6} className="mb-3">
                  <Form.Group id="firstName">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Enter your first name"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6} className="mb-3">
                  <Form.Group id="lastName">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Also your last name"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
      
              <Row className="align-items-center">
                <Col xs={12} md={6} className="mb-3">
                  <Form.Group id="birthday">
                    <Form.Label>Birthday</Form.Label>
                    <Datetime
                      dateFormat="MM/DD/YYYY"
                      timeFormat={false}
                      value={birthday ? moment(birthday).format("MM/DD/YYYY") : ""}
                      onChange={(date) => setBirthday(moment(date).format("YYYY-MM-DD"))}
                      renderInput={(props, openCalendar) => (
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faCalendarAlt} />
                          </InputGroup.Text>
                          <Form.Control
                            required
                            type="text"
                            placeholder="mm/dd/yyyy"
                            onFocus={openCalendar}
                            value={birthday ? moment(birthday).format("MM/DD/YYYY") : ""}
                            onChange={() => {}}
                          />
                        </InputGroup>
                      )}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6} className="mb-3">
                  <Form.Group id="gender">
                    <Form.Label>Gender</Form.Label>
                    <Form.Select value={gender} onChange={(e) => setGender(e.target.value)}>
                      <option value="0">Select Gender</option>
                      <option value="1">Female</option>
                      <option value="2">Male</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
      
              <Row>
                <Col xs={12} md={6} className="mb-3">
                  <Form.Group id="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      required
                      type="email"
                      placeholder="name@company.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6} className="mb-3">
                  <Form.Group id="phone">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      required
                      type="tel"
                      placeholder="+12-345 678 910"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
      
              <Row>
                <Col xs={12}>
                  <ChoosePhotoWidget
                    title="Select profile photo"
                    photo={profilePhoto || defaultAvatar}
                    onChange={handleProfilePhotoChange}
                    preview={profilePhotoPreview}
                  />
                </Col>
              </Row>
      
              {isLoading && (
                <div className="text-center mb-3">
                  <Spinner animation="border" role="status" />
                </div>
              )}
      
              <div className="mt-2 d-flex justify-content-end">
                <Button variant="primary" type="submit" size="sm">
                  Save All
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      
        <ToastContainer position="top-end" className="p-3">
          <Toast
            onClose={() => setShowAlert(false)}
            show={showAlert}
            delay={3000}
            autohide
            bg="success"
          >
            <Toast.Body className="text-white">Profile is updated successfully</Toast.Body>
          </Toast>
        </ToastContainer>
      </>
      
    );
};